import { Modal } from "react-bootstrap";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const RejectTicket = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [inputError, setInputError] = useState([]);
  const remarkInputRef = useRef();
  const [rejectData, setRejectData] = useState({
    REJECT_REASON: "",
  });

  const SendEmail = (_data) => { 
    let functionName = "onSaveConfirmHandler";

    try {
        props.onLoading(true, "Sending email, please wait...");
        const data = {
            TICKET_MST_ID: _data.TICKET_MST_ID,
            TICKET_NUM: _data.TICKET_NUM, 
            ORG_ID: _data.ORG_ID,   
            ORG_NAME: _data.ORG_NAME,
            SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
            SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
            UPDATE_ID: userId,
        };
        http
            .post("api/Ticket/SendRejectEmail", data, { timeout: common.DEFAULT_TIMEOUT })
            .then((response) => {
              props.onLoading(true, "Sending email...");
            })
            .catch((err) => {    
                common.c_LogWebError(props.page, functionName, err);
            })
            .finally(() => {
                props.onLoading(false, "Loading...");
            })


    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to send");
        common.c_LogWebError(props.page, functionName, err);
    }
  };

  const RejectBtnOnClick = () => {
    var flag = true;
    if (
      rejectData.REJECT_REASON === undefined ||
    Object.keys(rejectData.REJECT_REASON).length === 0
  ) {
    flag = false;
    setInputError((prevState) => ({
      ...prevState,
      REJECT_REASON: "Please fill in reject reason.",
    }));
  } else {
    setInputError((prevState) => ({
      ...prevState,
      REJECT_REASON: "",
    }));
    }
    if (flag) {
      RejectTicket(props.viewData);
    }
  }

  function RejectTicket(_data) {
    let functionName = "";
    try {
      functionName = "Reject Ticket";

      props.onLoading(true, "Rejecting ticket, please wait...");

      const data = {
        TICKET_MST_ID: _data.TICKET_MST_ID,
        TICKET_NUM: _data.TICKET_NUM,
        TICKET_VERIFY_ID: _data.TICKET_VERIFY_ID,
        REJECT_REASON: rejectData.REJECT_REASON,
        UPDATE_ID: userId,
      };

      http
        .post("api/ticket/RejectTicket", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.OPEN_STATUS === false) {
            if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "REJECTED") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been rejected." );   
            }                
            props.onReload();
            hideModal();
          }
          else {
            toast.success("Ticket is successfully rejected.");
            SendEmail(_data);
            props.onReload();
            hideModal();
          }     
        })
        .catch((err) => {
          toast.error("Failed to reject ticket. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
        props.onLoading(false, "Loading...");
        toast.error("Failed to reject ticket. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
    }
  }
  
  const hideModal = () => {
    props.onHide();
  };
  const showVerifyModal = () => {
    props.onHide();
    props.onShow();
  };


  
  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setRejectData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  useEffect(() => {
    if (props.showHide) {
      setRejectData({ REJECT_REASON: "" });
      setInputError({});
    }
  }, [props.showHide]);
  
  return (
    <> <Modal show={props.showHide} onHide={showVerifyModal} centered size='lg'>
    <Modal.Header>
      <div style={{ backgroundColor: "lightgrey", width: "100%", textAlign: "center" }}>
        <Modal.Title>Reject Ticket</Modal.Title>
      </div>
    </Modal.Header>
    <Modal.Body>
      <Comp.TextArea
              ref={remarkInputRef}
              id="REJECT_REASON"
              type="text"
            name="Reject Reason"
            rows={ 5}
              className="form-control"
              value={rejectData.REJECT_REASON}
              label = "Please fill in reject reason * :"
              errorMessage={inputError.REJECT_REASON}
              onChange={inputRequiredHandler}
            />     
    </Modal.Body>
    <Modal.Footer>
    <div style={{ textAlign: "center", width: "100%" }}>
          <Comp.Button type="general" onClick={RejectBtnOnClick}>
            Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
          </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={showVerifyModal}>
            Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
          </Comp.Button>
          </div>
    </Modal.Footer>
  </Modal>
      </>
  );
}

export default RejectTicket;